import axiosClient from "@/api/common/axiosClient.ts";
import { Draw } from "@/types/draw.ts";

export const getDraw = ({ id }: { id?: string | number }) => {
  return axiosClient.get<Draw>(`draws/${id}/`);
};
